<template>
  <div class="settings-wrapper">
    <div class="info">
      <img :src="userInfo.avatar" alt="" class="avatar" />
      <p class="name">{{ userInfo.nickName }}</p>
    </div>
    <div class="form">
      <div class="form-item">
        <div class="label">姓名</div>
        <span class="form-item-inner">{{
          developerInfo.name ? developerInfo.name : ' 未绑定'
        }}</span>
      </div>
      <div class="form-item">
        <div class="label">电话</div>
        <span v-if="developerInfo.phone" class="form-item-inner">
          {{ developerInfo.phone | savePhoneNumber }}
        </span>
        <span
          v-else
          class="form-item-inner unbindPhone"
          @click="handleToEdit('/account/modifyPhone?firstBindPhone=1')"
        >
          前往绑定手机号码
        </span>
        <!--屏蔽isDeveloper-->
        <!-- v-if="isDeveloper"-->
        <div
          v-if="isDeveloper"
          class="option"
          @click="handleToEdit('/account/modifyPhone')"
        >
          <!--屏蔽新增新手机号码入口
          {{ developerInfo.phone ? '修改' : '新增' }}
          -->
          <!--修改手机号码-->
          {{ developerInfo.phone ? '修改' : '' }}
        </div>
      </div>
      <div class="form-item">
        <div class="label">身份证</div>
        <span class="form-item-inner">{{
          developerInfo.id_card ? developerInfo.id_card : '未绑定'
        }}</span>
      </div>
      <div class="form-item">
        <div class="label">银行卡</div>
        <span class="form-item-inner">{{
          bankInfo.bank_card ? bankInfo.bank_card : '未绑定'
        }}</span>
        <!--屏蔽isDeveloper-->
        <!-- v-if="isDeveloper"-->
        <div
          v-if="isDeveloper"
          class="option"
          @click="handleToEdit('/income/settlementSet')"
        >
          {{ bankInfo.bank_card ? '修改' : '新增' }}
        </div>
      </div>
    </div>
    <div class="logout-btn" @click="handleLogout">退出账号</div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { protectPhoneNumber } from '@/utils/index';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo', 'developerInfo', 'bankInfo']),
    isDeveloper() {
      const { state } = this.developerInfo;
      return state === 1 || state === 2;
    },
  },
  filters: {
    savePhoneNumber(phoneNumber) {
      return protectPhoneNumber(phoneNumber);
    },
  },
  mounted() {
    this.Report('view', 'AccountSettingsPage');
  },
  methods: {
    ...mapMutations(['CLEAR_ALL_INFO', 'RESET_ROUTER']),
    handleLogout() {
      this.$dialog
        .confirm({
          message: '确认退出登录？',
        })
        .then(() => {
          this.CLEAR_ALL_INFO();
          this.RESET_ROUTER();
          this.$router.push({ path: '/login' });
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleToEdit(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.settings-wrapper {
  min-height: 80vh;
  padding: 60px 100px;
  background-color: #fff;
}
.info {
  text-align: center;

  .avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
  }
  .name {
    padding-top: 10px;
    font-size: 28px;
  }
}
.form {
  padding-top: 68px;
  .form-item {
    display: flex;
    align-items: center;

    min-height: 56px;
    padding-bottom: 35px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .label {
    min-width: 3em;
    margin-right: 36px;
    font-size: 26px;
    text-align: right;
  }
  .form-item-inner {
    flex: 1;
    width: 1%;
    height: 56px;
    padding: 12px 16px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    color: #8c8c8c;
    &.unbindPhone {
      color: #2b6ddf;
    }
  }
  .option {
    flex-shrink: 0;

    width: 5em;
    line-height: 56px;
    text-align: right;
    color: #2b6ddf;
  }
}
.logout-btn {
  height: 70px;
  margin-top: 80px;
  background: #fd9b21;
  border-radius: 8px;
  line-height: 70px;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
.van-form {
  margin-top: 30px;
}
.btn-forbid {
  background: #8c8c8c;
  color: #fff;
  border-color: #8c8c8c;
}
</style>
